import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function OmOss() {
  const [content, setContent] = useState({});

  useEffect(() => {
    axios.get(`${API_URL}/api/content/om-oss`)
      .then(response => {
        const organizedContent = response.data.reduce((acc, item) => {
          acc[item.element_id] = item;
          return acc;
        }, {});
        setContent(organizedContent);
      })
      .catch(error => console.error("Error fetching content:", error));
  }, []);

  const bilde = content['om_oss_bilde'];

  return (
    <div className="om-oss-layout">
      <Helmet>
      <title>Om Oss – Møt naprapat Alexander Øen Ask</title>
      <meta name="description" content="Møt Alexander Øen Ask, din autoriserte naprapat i Førde. Les om hans erfaring med behandling av smertepasienter og idrettsutøvere." />
    </Helmet>
      {content.om_oss_tittel && <h1>{content.om_oss_tittel.value}</h1>}
      
      {bilde && (
        <div className={`content-block ${bilde.layout}`}>
          <img src={bilde.value} alt="Portrett av naprapat Alexander Øen Ask" />
          <div className="text-content">
            {content.om_oss_p1 && <p>{content.om_oss_p1.value}</p>}
            {content.om_oss_p2 && <p>{content.om_oss_p2.value}</p>}
            {content.om_oss_p3 && <p>{content.om_oss_p3.value}</p>}
          </div>
        </div>
      )}
    </div>
  );
}

export default OmOss;